<template>
	<div>
		<Titlebar />
		<p>Select a leaderboard below to moderate it.</p>
		<div class="forms">
			<p v-if="is('error')">Failed to load leaderboards.</p>
			<p v-if="is('loading')">Loading...</p>
			<template v-else>
				<ModerationForm
					v-for="event of events"
					:key="event._id"
					:event="event"
					ref="event"
					@ban="onBan"
				/>
			</template>
		</div>
	</div>
</template>

<script>
import { ACTIVE_EVENT, GLOBAL_EVENT } from 'recycle-race-common/lib/constants'
import Titlebar from '@/components/Titlebar'
import ModerationForm from '@/forms/ModerationForm'
import state from '@/mixins/state'
import { EventProvider } from '@/lib/dataProvider'

export default {
	name: 'Moderation',
	data() {
		return {
			loads: 0,
			eventIds: [ACTIVE_EVENT, GLOBAL_EVENT],
			events: [],
		}
	},
	methods: {
		async loadEvents() {
			this.setState('loading')
			try {
				this.events = await Promise.allSettled(this.eventIds.map(EventProvider.get)).then(
					results => {
						// Fail if every promise rejected
						if (results.every(result => result.status === 'rejected')) {
							throw new Error('Failed to load leaderboards.')
						} else {
							return results
								.filter(result => result.status === 'fulfilled')
								.map(result => result.value)
						}
					}
				)
				this.setState('idle')
			} catch (err) {
				this.setState('error')
			}
		},
		onBan() {
			this.$refs.event.forEach(form => {
				form.getLeaderboards()
			})
		},
	},
	created() {
		this.loadEvents()
	},
	mixins: [state()],
	components: {
		Titlebar,
		ModerationForm,
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/layout';

.forms {
	@include form-spacing;
}
</style>
